
import {defineComponent, PropType} from "vue";
import {Campaign} from "@/models/campaign";

export default defineComponent({
    props: {
        campaign: { type: Object as PropType<Campaign>, required: true },
    },
    computed: {
        hasVideoURLs(): boolean {
            const videoURLs = this.validateVideoURLs(this.campaign.videoURLs);
            if (videoURLs) {
                return videoURLs.length > 0;
            }

            return false;
        },
    },
    methods: {
        validateVideoURLs(videoURLs: string[] | null | undefined): string[] | null {
            if (!videoURLs) {
                return null;
            }

            return videoURLs.filter((videoURL: string) => {
                return this.validateVideoURL(videoURL);
            });
        },

        validateVideoURL(videoURL: string): boolean {
            const pattern = /(http(s?):)([/|.|\w|\s|-])*\.(?:mp4|webm|ogg)$/;
            return pattern.test(videoURL);
        },
    },
});
